module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1066.1dcf055f.png";